import styled from "styled-components";

export default styled.div`
  width: 100%;
  height: 100%;

  .delete-modal {
    width: 100%;
    height: 100%;

    display: flex;
    align-items: center;
    justify-content: center;

    .delete-modal-background {
      position: absolute;
      width: 100%;
      height: 100%;
      cursor: pointer;
      top: 0;
      left: 0;
    }

    .delete-modal-content {
      max-width: 500px;
      width: 90vw;
      background-color: white;
      padding: 1.5rem;
      border-radius: 16px;
      z-index: 3;
      position: relative;
      display: flex;
      flex-flow: column;
      gap: 4rem;

      .delete-modal-text {
        display: flex;
        flex-flow: column;
        gap: 0.5rem;
      }

      .delete-modal-button {
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }
`;
